import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { Projects } from '../../project-manager/models/project.model';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { FavoritesItems, FavoritesItemsModel } from '../../../models/dashboard.model';
import { EnvironmentService } from 'src/app/services/environment.service';

@Injectable({
    providedIn: 'root',
})
export class DashboardService {
    headers: HttpHeaders;
    private reportApi = environment.reportApi;
    // private subVal = environment.subValue;

    private logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
    isDashBoardView: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    favoritesItems: BehaviorSubject<FavoritesItems> = new BehaviorSubject<FavoritesItems>(null);
    refreshFavoritesItems: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    openJointDetailsByTaggedId: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor(
        private http: HttpClient,
        private authService: MsalService,
        private EnvironmentService: EnvironmentService,
        private appInsights: ApplicationInsights
    ) {}

    addPostAndPutHeaders() {
        this.headers = new HttpHeaders();
        this.headers = this.headers.append('Ocp-Apim-Subscription-Key', this.EnvironmentService.getConfig().subValue);
        this.headers = this.headers.append('Accept', 'application/json;');
        this.headers = this.headers.append('Access-Control-Allow-Origin', '*/*');
        this.headers = this.headers.append('content-type', 'application/json');
        this.headers = this.headers.append('InstanceId', `${localStorage.getItem('currentInstanceId')}`);
        this.headers = this.headers.append('Authorization', `Bearer ${localStorage.getItem('msal.accessToken')}`);
    }

    getCurrentProjects(): Observable<{ success: boolean; isCustom?: boolean; message?: string; response?: Projects[] }> {
        const url = `${this.reportApi}dashboard/getcurrentprojects`;
        this.addPostAndPutHeaders();
        return this.http
            .get(url, {
                headers: this.headers,
            })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getInstanceHistory(days: number): Observable<any> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.reportApi}dashboard/getinstancehistory/` + days, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getDatabaseItems(): Observable<any> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.reportApi}dashboard/getdatabaseitems`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getFavourites(): Observable<FavoritesItemsModel> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.reportApi}dashboard/getfavourites`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getLeaksPercentage(weeks: number): Observable<any> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.reportApi}dashboard/getleakspercentage/` + weeks, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getLeaksReported(weeks: number): Observable<any> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.reportApi}dashboard/getleaksreported/` + weeks, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getFailedInspections(weeks: number): Observable<any> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.reportApi}dashboard/getfailedinspections/` + weeks, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getCurrentActivityPacks(): Observable<any> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.reportApi}dashboard/getcurrentactivitypacks/`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getProjectSlippage(take: number): Observable<any> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.reportApi}dashboard/getprojectslippage/` + take, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getJointsDisturbed(weeks: number): Observable<any> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.reportApi}dashboard/getjointsdisturbed/` + weeks, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getJointsCompleted(weeks: number): Observable<any> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.reportApi}dashboard/getjointscompleted/` + weeks, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    private handleError(error: any) {
        this.logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
        let currOrg = localStorage.getItem('selectedOrgId');
        let currInstance = localStorage.getItem('currentInstanceId');
        if (error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.message);

            this.appInsights.trackException({
                exception: new Error(error.message),
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId },
            });
            this.appInsights.trackPageView({ properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId } });
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.message}`);
            this.appInsights.trackException({
                exception: new Error(error.message),
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId },
            });
            this.appInsights.trackPageView({ properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId } });
        }
        // Return an observable with a user-facing error message.
        return throwError('Something bad happened; please try again later.');
    }
}
